module.exports = __webpack_public_path__ + "static/media/servicesrecaudo.b5d92440.png";